export const MENU_LIST = 'MENU_LIST'
export const SCROLL_Y = 'SCROLL_Y'
export const ADD_CACHED_INCLUDE = 'ADD_CACHED_INCLUDE'
export const REMOVE_CACHED_INCLUDE = 'REMOVE_CACHED_INCLUDE'
export const ADD_CACHED_EXCLUDE = 'ADD_CACHED_EXCLUDE'
export const REMOVE_CACHED_EXCLUDE = 'REMOVE_CACHED_EXCLUDE'
export const CHANGE_NETWORK = 'CHANGE_NETWORK'
